<template>
    <div class="profile-videos">
        <div class="profile-videos__add">
            <v-alert
                v-if="new_video_duplicate"
                :value="true"
                type="error"
                class="notranslate"
            >{{ $t('This video has already been added') }}</v-alert>
            <span class="limit">{{ available > 0
                ? $t('You can send up to more', { available })
                : $t('You have reached the video limit')
            }}</span>
            <v-form v-model="new_video.valid"
                    ref="new_video_form"
                    @submit.prevent="confirmVideo"
                    v-if="available > 0"
            >
                <v-text-field
                    class="video_url_input my-0"
                    v-model="new_video.url"
                    :label="$t('Video URL')"
                    :rules="[form_rules.required, form_rules.video]"
                    :disabled="new_video.loading"
                ></v-text-field>
                <v-btn type="submit"
                       class="ml-2 my-0"
                       style="color: #fff;"
                       :loading="new_video.loading"
                       :disabled="new_video.loading || !new_video.valid"
                       color="accent"
                >{{ $t('Confirm') }}</v-btn>
            </v-form>
            <span class="note" v-if="available > 0">{{ $t('Fill the field with a valid URL') }}</span>
        </div>
        <div class="profile-videos__container">
            <div v-for="(video, index) in videos"
                :class="{
                'profile-videos__single': true,
                'removing': removing === video.url
                 }"
                 :key="index"
            >
                <div class="video_thumbnail"
                     :style="`background-image: url(${video.thumbnail})`"></div>
                <div class="video_info">
                    <div class="video_title" v-html="video.title"></div>
                    <div class="video_url">{{video.url}}</div>
                </div>
                <v-tooltip left class="remove_video">
                    <v-btn slot="activator"
                           flat
                           icon
                           color="rgba(0,0,0,0.54)"
                           @click="removeVideo(video.url)"
                    >
                        <v-icon class="notranslate" medium>delete</v-icon>
                    </v-btn>
                    <span>{{ $t('Remove video') }}</span>
                </v-tooltip>
            </div>
        </div>
        <v-alert
            v-if="error"
            :value="true"
            type="error"
            class="notranslate"
        >{{ $t('There is a problem with the provided URL') }}</v-alert>
    </div>
</template>

<script>
import VAlert from 'vuetify/es5/components/VAlert/VAlert'
import VTextField from 'vuetify/es5/components/VTextField/VTextField'
import { addVideo, removeVideo } from '../utils/api'
import { UPDATE_SEGMENTS } from '../store/types'
import form_rules_mixin from "../utils/form_rules_mixin";
export default {
  name: 'ProfileVideos',
  components: { VAlert, VTextField },
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  mixins: [
    form_rules_mixin
  ],
  data: () => ({
    error: false,
    removing: '',
    videos: [],
    new_video: {
      valid: false,
      loading: false,
      url: ''
    }
  }),
  mounted () {
    this.videos = this.$store.state.segments.find(el => {
      return el.data.id === this.id
    }).data.media
  },
  computed: {
    limit: function () {
      return parseInt(this.$store.state.segments.find(el => {
        return el.data.id === this.id
      }).data['media_limit'], 10)
    },
    available: function () {
      return (this.limit - this.videos.length)
    },
    new_video_duplicate: function () {
      const index = this.videos.find(el => el.url === this.new_video.url)
      return !(index == null)
    }
  },
  methods: {
    getVideoDetails: function (url) {
      if (url.includes('youtube.com')) {
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/
        const match = url.match(regExp)
        const videoId = (match && match[7].length === 11) ? match[7] : false
        return fetch(`https://noembed.com/embed?url=https://www.youtube.com/watch?v=${videoId}`, {
          method: 'GET'
        }).then(res => res.json())
      } else {
        let videoId = url.replace(/^\D+/g, '')
        return fetch(`https://vimeo.com/api/v2/video/${videoId}.json`, {
          method: 'GET'
        }).then(res => res.json())
      }
    },
    confirmVideo: function () {
      this.new_video.loading = true
      this.error = false
      this.getVideoDetails(this.new_video.url).then(video => {
        console.log(video)
        addVideo(
          this.id,
          Array.isArray(video) ? video[0].title : video.title,
          Array.isArray(video) ? video[0].url : video.url,
          Array.isArray(video) ? video[0]['thumbnail_large'] : video['thumbnail_url']
        )
          .then(result => {
            this.$store.commit(UPDATE_SEGMENTS, result)
            this.$refs.new_video_form.reset()
            this.new_video.loading = false
            this.videos.push({
              title: Array.isArray(video) ? video[0].title : video.title,
              url: Array.isArray(video) ? video[0].url : video.url,
              thumbnail: Array.isArray(video) ? video[0]['thumbnail_large'] : video['thumbnail_url'],
            })
            if (this.videos.length >= 3) {
              this.$emit('after-submit-alerts');
            }
          })
      }).catch(e => {
        console.log(e)
        this.new_video.loading = false
        this.error = true
      })
    },
    removeVideo: function (videoURL) {
      this.removing = videoURL
      removeVideo(this.id, videoURL).then(result => {
        if (result['result'] === 'success') {
          console.log(videoURL)
          console.log(this.videos)
          const index = this.videos.findIndex(el => el.url === videoURL)
          console.log(index)
          this.videos.splice(index, 1)
        }
        this.removing = ''
      })
    }
  }
}
</script>

<style scoped lang='scss'>
    .profile-videos__add {
        background: #f5f5f5;
        border-radius: 8px;
        max-width: 720px;
        margin: 24px auto;
        padding: 36px;
        text-align: center;
        .limit {
            display: block;
            font-size: 16px;
        }
        .note {
            display: block;
            font-size: 13px;
            margin-top: 12px;
        }
        .v-form {
            display: flex;
            align-items: center;
            .video_url_input {
                flex: 1;
            }
        }
    }
    .profile-videos__container {
        margin-bottom: 24px;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-row-gap: 6px;
        grid-column-gap: 18px;
        .profile-videos__single {
            height: 72px;
            clear: both;
            margin-top: 18px;
            position: relative;
            overflow: hidden;
            background: #fafafa;
            border-radius: 4px;
            .video_thumbnail {
                width: 128px;
                height: 72px;
                border-radius: 4px;
                background-color: #ccc;
                float: left;
                background-size: cover;
                background-position: center center;
            }
            .video_info {
                float: left;
                width: calc(100% - 140px);
                height: 72px;
                margin-left: 12px;
            }
            .video_title {
                width: calc(100% - 64px);
                overflow: hidden;
                white-space: nowrap;
                line-height: 24px;
                height: 24px;
                font-weight: bold;
                font-size: 16px;
                color: rgba(0,0,0,0.87);
                margin-top: 12px;
            }
            .video_url {
                white-space: nowrap;
                font-size: 16px;
                line-height: 24px;
                height: 24px;
                color: rgba(0,0,0,0.54);
                margin-bottom: 12px;
            }
            .remove_video {
                position: absolute;
                top: 12px;
                right: 12px;
                background: #fafafa;
            }
            &.removing {
                opacity: 0.5;
                pointer-events: none;
            }
        }
    }
    .v-alert {
        clear: both;
    }
</style>

<i18n>
    {
        "en": {
            "This video has already been added": "The URL of the video you have entered has already been added",
            "You can send up to more": "You can send up to {available} videos",
            "You have reached the video limit": "You have reached the video limit",
            "Video URL": "Video URL",
            "Fill the field with a valid URL": "Fill in the field with a valid Youtube or Vimeo video URL.",
            "Remove video": "Remove video",
            "There is a problem with the provided URL": "There is a problem with the provided URL. Please check and try again"
        },
        "pt": {
            "This video has already been added": "O URL do vídeo que você preenchou já foi adicionado anteriormente",
            "You can send up to more": "Você pode enviar até mais {available} vídeos",
            "You have reached the video limit": "Você atingiu o limite de vídeos",
            "Video URL": "URL do vídeo",
            "Fill the field with a valid URL": "Preencha o campo com um URL de vídeo válido do Youtube ou Vimeo.",
            "Remove video": "Remover vídeo",
            "There is a problem with the provided URL": "Houve um problema com o URL fornecido. Verifique e tente novamente"
        }
    }
</i18n>
